import React, { useState, useRef, useEffect } from "react";

const ReactionTimeGame = () => {
  const [gameState, setGameState] = useState("waiting"); // waiting | ready | clicked
  const [message, setMessage] = useState("Click to start!");
  const [reactionTime, setReactionTime] = useState(null);
  const [highScore, setHighScore] = useState(
    localStorage.getItem("highScore") || null
  );

  const timeoutRef = useRef(null);
  const startTimeRef = useRef(null);

  const startGame = () => {
    setGameState("waiting");
    setReactionTime(null);
    setMessage("Wait for red...");

    const delay = Math.random() * 3000 + 2000; // 2s to 5s

    timeoutRef.current = setTimeout(() => {
      setGameState("ready");
      setMessage("CLICK NOW!");
      startTimeRef.current = new Date().getTime();
    }, delay);
  };

  const handleClick = () => {
    if (gameState === "waiting") {
      // Clicked too early
      clearTimeout(timeoutRef.current);
      setMessage("Too soon! Click to try again.");
      setGameState("clicked");
    } else if (gameState === "ready") {
      const endTime = new Date().getTime();
      const time = endTime - startTimeRef.current;
      setReactionTime(time);
      setMessage(`Your reaction time is ${time}ms. Click to try again.`);
      setGameState("clicked");

      // Update high score
      if (!highScore || time < highScore) {
        setHighScore(time);
        localStorage.setItem("highScore", time);
      }
    } else {
      startGame();
    }
  };

  useEffect(() => {
    // Cleanup timeout if component unmounts
    return () => clearTimeout(timeoutRef.current);
  }, []);

  const getBackgroundColor = () => {
    if (gameState === "ready") return "#ff4d4f"; // red
    if (gameState === "waiting") return "#d3d3d3"; // grey
    return "#ffffff"; // white after clicked
  };

  return (
    <div
      onClick={handleClick}
      style={{
        height: "100vh",
        backgroundColor: getBackgroundColor(),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "24px",
        fontWeight: "bold",
        cursor: "pointer",
        userSelect: "none",
        textAlign: "center",
      }}
    >
      <div>{message}</div>
      {reactionTime && (
        <div style={{ marginTop: "20px", fontSize: "20px" }}>
          Fastest: {highScore}ms
        </div>
      )}
    </div>
  );
};

export default ReactionTimeGame;
